module.exports = __webpack_public_path__ + "static/media/cost.d4d1d1d8.png";